import Vue from 'vue'
import { Tool } from '@/util/index'
const tool = new Tool()

Vue.filter('columnRender', function (data, render) {
  const key = render.value
  const value = data[render.value]
  return tool.adapterValue(key, value)
})

Vue.filter('fieldRender', function (value, format) {
  let text

  if (tool.isNotEmpty(value)) {
    switch (format) {
      case 'currency':
        text = tool.formatCurrency(value)
        break
      case 'date':
        text = tool.formatDate(value)
        break
      case 'datetime':
        text = tool.formatDateTime(value)
        break
      default:
        text = value
        break
    }
  } else {
    text = 'N/A'
  }

  return text
})
